"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefetchSnaps = void 0;
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const isResponseUnhealthy = (response) => response.status < 200 || response.status >= 300;
async function downloadMedia(mediaUrl, snap) {
    if (!mediaUrl) {
        return Promise.resolve({ error: new Error("No media URL") });
    }
    return fetch(mediaUrl)
        .then(async (response) => {
        if (isResponseUnhealthy(response)) {
            void (0, web_graphene_reporting_1.incrementCounter)(`Prefetching.Media.Failure.${response.status}`);
            const id = snap ? snap.storyId : "unknown";
            const error = new Error(`downloadMedia for story ${id}: ${response.statusText}`);
            error.message = `downloadMedia for story ${id}`;
            return {
                error,
            };
        }
        void (0, web_graphene_reporting_1.incrementCounter)(`Prefetching.Media.Success`);
        const data = await response.arrayBuffer();
        return {
            data: data,
        };
    })
        .catch((error) => {
        console.error(error);
        return {
            error: error,
        };
    });
}
const createPrefetchedMedia = (type, downloadedMedia) => {
    if (!downloadedMedia.data || downloadedMedia.error) {
        return {
            error: "Snap prefetch request failed",
        };
    }
    const data = downloadedMedia.data;
    if (data.byteLength === 0) {
        return {
            error: "Snap does not exist",
        };
    }
    const mediaBlob = new Blob([data], {
        type,
    });
    return {
        blobUrl: URL.createObjectURL(mediaBlob),
    };
};
const createPrefetchedSnap = (prefetchedMedia, storyId) => {
    const prefetchedSnap = {
        snapId: storyId,
        mediaBlob: prefetchedMedia,
    };
    const errors = [];
    if (prefetchedMedia.error) {
        errors.push(prefetchedMedia.error);
    }
    if (errors.length > 0) {
        prefetchedSnap.errors = errors;
    }
    return prefetchedSnap;
};
var MediaMimeType;
(function (MediaMimeType) {
    MediaMimeType["VIDEO_MP4"] = "video/mp4";
})(MediaMimeType || (MediaMimeType = {}));
const processMedia = (downloadedMedia) => createPrefetchedMedia(MediaMimeType.VIDEO_MP4, downloadedMedia);
const prefetchMedia = async (mediaUrl, snap) => downloadMedia(mediaUrl, snap).then((downloadedMedia) => processMedia(downloadedMedia));
async function prefetchSnaps(snaps) {
    return Promise.all(snaps.map(async (snap) => {
        const prefetchedMedia = await prefetchMedia(snap.mediaUrl, snap);
        return createPrefetchedSnap(prefetchedMedia, snap.storyId);
    }));
}
exports.prefetchSnaps = prefetchSnaps;
//# sourceMappingURL=media.js.map